import React from 'react';
import { Box } from '@mui/system';
import useStyles from '../styles';
import { Grid } from '@mui/material';
import { FormGroup } from '@mui/material';
import { usePageLevelScriptConfigContext } from '../../../../../../../Contexts/PageLevelScriptConfigContext';
import InputConfig from '../../../../../../../Components/InputConfig';
import PageLevelScriptSectionSplitConfig from './PageLevelScriptSectionSplitConfig';

/**
 * SinglePageLevelScriptConfig: A component for managing the config of a single page.
 *
 * Features:
 * - Allows editing the URL of the page if the page is deletable.
 * - Integrates PageLevelScriptSectionSplitConfig to manage section splits for the page.
 * */
const SinglePageLevelScriptConfig = ({ config }) => {
	const classes = useStyles();
	const { setPageLevelScriptConfigData, setPageLevelScriptConfigMode } =
		usePageLevelScriptConfigContext();

	const handlePageUrlChange = (value) => {
		setPageLevelScriptConfigData((prevConfigData) => updatePageUrl(prevConfigData, value));
	};

	const updatePageUrl = (data, value) => {
		const clonedData = structuredClone(data);
		const updatedConfigwithUpdatedPageUrl = clonedData.map((prevConfig) => {
			if (prevConfig.id === config.id) {
				prevConfig.pageUrl = value;
			}
			return prevConfig;
		});
		return updatedConfigwithUpdatedPageUrl;
	};

	const canEditPage = !!config.isDeletable;

	return (
		config && (
			<Box>
				<FormGroup
					style={{
						margin: '1rem 0 0 0',
						display: 'flex',
						justifyContent: 'center'
					}}
				>
					<Grid container spacing={2} className={classes.inputConfig}>
						<Grid item xs={12}>
							<InputConfig
								isObjectEditor={false}
								label="Page URL"
								directValue={config.pageUrl}
								updateDirectValue={(value) => handlePageUrlChange(value)}
								inputStyles={{ width: '100%', margin: '1rem 0' }}
								editable={canEditPage}
								labelStyles={{
									fontSize: '2.4rem',
									lineHeight: '1.334',
									textAlign: 'left',
									width: '100%'
								}}
							/>
						</Grid>
					</Grid>

					<Box
						container
						sx={{
							height: '70vh',
							overflowX: 'scroll',
							border: '1px solid rgba(0, 0, 0, 0.38)',
							borderRadius: '4px',
							paddingX: '1rem',
							paddingY: '1rem'
						}}
					>
						<PageLevelScriptSectionSplitConfig />
					</Box>
				</FormGroup>
			</Box>
		)
	);
};

export default SinglePageLevelScriptConfig;
